import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfSwiperOnlyH5 from '@elem/ui/ef-swiper-only-h5';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionF');
    const listA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724651727536/smaller%20than%20the%20industry%20average.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724651727179/smaller%20than%20the%20industry%20average%20(1).jpg',
            section: (
                <div className="Section-a">
                    <div className="Section-a-title">{t('a_title')}</div>
                    <div className="Section-a-desc">{t('a_desc')}</div>
                </div>
            ),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724651727007/smaller.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724651727359/lightweight.jpg',
            section: <></>,
        },
    ];
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfSwiperOnlyH5 items={listA} loop={true} />
        </div>
    );
}
